module.exports = __webpack_public_path__ + "img/letters.089a27b4.png";